import { useQueryLog, useQueryStart } from "features/start/data";


export const useStart = () => {
	const query = useQueryStart();
	const profile = query.data?.user?.profiles?.[0]; /* temporary while we only support one profile */

	const profiles = query.data?.user?.profiles;

	return {
		...query.data,
		profile,
		profiles: {
			personal: profiles?.find(p => p.type === "Personal"),
			partner: profiles?.find(p => p.type === "Partner")
		}
	};;
};

export const useLog = useQueryLog;